module.exports = __webpack_public_path__ + "static/media/porsche-wallpaper-_1_.211d6bbf.jpg";